import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";
import clip from "text-clipper";

export default class ReadMoreBehaviour extends AbstractDataAttributeBehaviour {
  selector = 'data-read-more';

  getContainerSelector()
  {
    return '[' + this.selector + ']';
  }

  createReadMore(){
    const el = document.createElement('span');
    el.textContent = ' Read more';
    el.className = 'read-more-link text-link no-icon';

    return el;
  }

  createShowLess(){
    const el = document.createElement('span');
    el.textContent = ' Show less';
    el.className = 'read-more-link text-link no-icon';

    return el;
  }

  handleToggle(button, container, text, callback){
    button.addEventListener('click', () => {
      container.innerHTML = text;
      callback(container);
    });
  }

  initContainer(container) {
    const originalContent = container.innerHTML;
    const clippedContent = clip(container.innerHTML, container.getAttribute(this.selector));
    const readMoreButton = this.createReadMore();
    const readLessButton = this.createShowLess();

    container.innerHTML = clippedContent;
    if (originalContent.length > clippedContent.length) {
      container.lastElementChild ? container.lastElementChild.appendChild(readMoreButton) : container.append(readMoreButton);
    }


    this.handleToggle(readMoreButton, container, originalContent, (container) => {
      container.lastElementChild ? container.lastElementChild.appendChild(readLessButton) : container.append(readLessButton);
    });

    this.handleToggle(readLessButton, container, clippedContent, (container) => {
      container.lastElementChild ? container.lastElementChild.appendChild(readMoreButton) : container.append(readMoreButton);
    });
  }
}